module.exports = __webpack_public_path__ + "img/Uhse_Cercle.70dda112.png";